





import { defineComponent } from '@vue/composition-api';

import PanelWithProductEditor from '@/components/Store/PanelWithProductEditor.vue';

const New = defineComponent({
  components: {
    PanelWithProductEditor,
  },
  // setup() {},
});

export default New;
